import React, { useState, useEffect } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  TextField,
  Fade,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";

// styles
import useStyles from "./styles";

// logo
import logo from "../../images/testntel-logo.png";

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";

function Login(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [loginValue, setLoginValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");

  useEffect(() => {
    let mounted = true;

    if(mounted) {
      if (error && isLoading) {
        userDispatch({ type: "LOGIN_FAILURE" });
      }
    }

    return () => mounted = false;
  }, []);

  function handleLogin (e) {
      e.preventDefault();
      setError(false);
      setIsLoading(true);

     loginUser(
        userDispatch,
        loginValue,
        passwordValue,
        props.history
      ).then(response => {
        //setSuccess(response);
        if (response !== undefined && !response) {
          setError(true);
          setIsLoading(false);
        }
    });
  }

  function getCurrentYear(){
      return new Date().getFullYear();
  }


  return (
    <Grid container className={classes.container}>
      <div className={classes.logotypeContainer}>
        <img src={logo} alt="logo" className={classes.loginLogotypeImage} />
        {/*<Typography className={classes.logotypeText}>Test and Tag</Typography>*/}
      </div>

      <div className={classes.formContainer}>
        <div className={classes.form}>
          {<React.Fragment>
            <form onSubmit={handleLogin} autoComplete="on">
            <Typography variant="h1" className={classes.greeting}>
              Welcome{process.env.REACT_APP_ENV.includes('production') ? '!' : ` to ${process.env.REACT_APP_ENV}!`}
            </Typography>
            <Fade in={error}>
              <Typography color="secondary" className={classes.errorMessage}>
                Login Error.
              </Typography>
            </Fade>
            <TextField
              id="email"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={loginValue}
              onChange={e => setLoginValue(e.target.value)}
              margin="normal"
              placeholder="Login Name"
              type="text"
              autoComplete="on"
              fullWidth
            />
            <TextField
              id="password"
              InputProps={{
                classes: {
                  underline: classes.textFieldUnderline,
                  input: classes.textField,
                },
              }}
              value={passwordValue}
              onChange={e => setPasswordValue(e.target.value)}
              margin="normal"
              placeholder="Password"
              type="password"
              autoComplete="on"
              fullWidth
            />
            <div className={classes.formButtons}>
              {isLoading ? (
                <CircularProgress size={26} className={classes.loginLoader} />
              ) : (
                <Button
                  className={classes.loginButton}
                  type="submit"
                  disabled={
                    loginValue.length === 0 || passwordValue.length === 0
                  }
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Login
                </Button>
              )}
            </div>
          </form>
          </React.Fragment>
        }
        </div>

        <Typography color="primary" className={classes.copyright}>
          ©{getCurrentYear()} TESTntel. All rights reserved.
        </Typography>
      </div>

    </Grid>
  );
}

export default withRouter(Login);
